import { createSlice } from "@reduxjs/toolkit";
import { getMainHours, createOrUpdateMainHours } from "../services/mainHours";

interface MainHoursState {
  mainHoursStatus: string;
  isSave: boolean;
  isError: boolean;
  mainHoursData: unknown[];
  currentItem: unknown | null;
}

const initialState: MainHoursState = {
  mainHoursStatus: "idle",
  isSave: false,
  isError: false,
  mainHoursData: [],
  currentItem: null,
};

const mainHoursSlice = createSlice({
  name: "mainHours",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMainHours.pending, (state) => {
        state.mainHoursStatus = "pending";
      })
      .addCase(getMainHours.fulfilled, (state, action) => {
        const payload = action.payload as { data: { data: unknown[] } };
        state.mainHoursStatus = "success";
        state.mainHoursData = payload.data.data;
      })
      .addCase(getMainHours.rejected, (state) => {
        state.mainHoursStatus = "rejected";
      })
      .addCase(createOrUpdateMainHours.pending, (state) => {
        state.isSave = true;
        state.isError = false;
        state.mainHoursStatus = "save:pending";
      })
      .addCase(createOrUpdateMainHours.fulfilled, (state, action) => {
        const payload = action.payload as { data: { data: unknown[] } };
        state.mainHoursStatus = "success";
        state.isSave = false;
        state.isError = false;
        state.mainHoursData = payload.data.data;
      })
      .addCase(createOrUpdateMainHours.rejected, (state) => {
        state.mainHoursStatus = "save:rejected";
        state.isSave = false;
        state.isError = true;
      });
  },
});

export default mainHoursSlice.reducer;
